module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/256-georgia-898606a93d4382f1070efdfb992ebfa1.svg";